import { FC, useMemo } from "react";

import { countInstancesByOwnerType } from "@/domain/_shared/lib/count-instances-by-owner-type";
import { useWorkspaceTerminology } from "@/domain/workspace/hooks/use-workspace-terminology";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";

export interface InstanceCountTagProps {
  instanceList?: Array<{ ownerType?: string }>;
  className?: string;
}

export const InstanceCountTag: FC<InstanceCountTagProps> = ({ className, instanceList }) => {
  const { currentWorkspace } = useCurrentWorkspaceContext();
  const terminology = useWorkspaceTerminology(currentWorkspace.id);
  const counts = useMemo(() => countInstancesByOwnerType(instanceList), [instanceList]);

  if (counts.climateActionCount === 0 && counts.projectCount === 0) {
    return <></>;
  }

  const parts: string[] = [];

  if (counts.climateActionCount > 0) {
    if (counts.climateActionCount === 1) {
      parts.push(`1 ${terminology.climateAction.singular}`);
    } else {
      parts.push(`${counts.climateActionCount} ${terminology.climateAction.plural}`);
    }
  }

  if (counts.projectCount > 0) {
    if (counts.projectCount === 1) {
      parts.push(`1 ${terminology.project.singular}`);
    } else {
      parts.push(`${counts.projectCount} ${terminology.project.plural}`);
    }
  }

  return <div className={className}>{parts.join(", ")}</div>;
};
